import { BaseApiService, API_CONFIG } from './base.service';
import {
  User,
  UserCreate,
  PaginatedResponse
} from '../../types';

/**
 * Service for managing users
 */
export class UserService extends BaseApiService {
  async getUsers(page: number = 1, pageSize: number = 10): Promise<PaginatedResponse<User>> {
    return this.getPaginated(API_CONFIG.ENDPOINTS.USERS, page, pageSize);
  }

  async getAllUsers(limit: number = 100): Promise<User[]> {
    const validLimit = Math.max(1, Math.floor(limit) || 100);
    const url = `${API_CONFIG.ENDPOINTS.USERS}/?skip=0&limit=${validLimit}`;
    console.log('getAllUsers - requesting URL:', url);
    const response = await this.get<any>(url);
    // Handle both array response and paginated response object
    if (Array.isArray(response)) {
      return response;
    } else if (response && response.items && Array.isArray(response.items)) {
      return response.items;
    } else {
      console.warn('getAllUsers: Unexpected response format:', response);
      return [];
    }
  }

  async getUser(id: number): Promise<User> {
    return this.get(`${API_CONFIG.ENDPOINTS.USERS}/${id}`);
  }

  async createUser(user: UserCreate): Promise<User> {
    return this.post(`${API_CONFIG.ENDPOINTS.USERS}/`, user);
  }

  async updateUser(id: number, user: Partial<UserCreate>): Promise<User> {
    return this.put(`${API_CONFIG.ENDPOINTS.USERS}/${id}`, user);
  }

  async deleteUser(id: number): Promise<void> {
    await this.delete(`${API_CONFIG.ENDPOINTS.USERS}/${id}`);
  }
}

export const userService = new UserService();